import { ChevronRightIcon } from "@heroicons/react/outline";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PhoneIcon } from "@heroicons/react/solid";
import { Modal } from "../Modal";

const menuCustomerServices = [
  { label: "Taxation", value: "taxation" },
  { label: "Applications & Transactions", value: "applications" },
  { label: "Complaints and General Services", value: "complaints" },
  { label: "Contact via Email", value: "contact" },
];

export const CSButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [openModal, setopenModal] = useState(false);

  const handleClick = (value) => {
    if (value === "taxation") {
      navigate("/consultation/form");
    } else if (value === "complaints") {
      window.location.href = "https://s.id/pajakindcs";
    } else if (value === "applications") {
      window.location.href = "https://s.id/pajakindts";
    } else if (value === "contact") {
      window.location.href = "mailto:cs@pajakind.com";
    }
  };

  return (
    <div>
      <Modal
        title="Customer Service"
        show={openModal}
        onClose={() => setopenModal(false)}
      >
        <div className="flex flex-col text-sm text-slate-500 p-4 gap-4">
          {menuCustomerServices.map((item, index) => (
            <button
              key={index}
              className="flex justify-between items-center text-center gap-4"
              onClick={() => handleClick(item.value)}
            >
              <span>{t(item.label)}</span>
              <ChevronRightIcon className="flex-none h-5 w-5" />
            </button>
          ))}
        </div>
      </Modal>
      <button
        onClick={() => setopenModal(true)}
        className="w-full block font-medium text-gray-700 text-sm sm:text-base"
      >
        <div className="flex gap-4 items-center">
          <PhoneIcon className="flex-none h-6 w-6" />
          <div className="flex-1 text-left">{t("Customer Service")}</div>
          <ChevronRightIcon className="h-6 w-6" />
        </div>
      </button>
    </div>
  );
};
